import { Grid } from '@mui/material';
import React from 'react';
import { formattedByteValues, formattedMetricValues } from '../../../../lib';
import { dashboardStyles } from '../../dashboard-helper';
import { DataCard } from '../data-card/DataCard';
import { DataDisabledCard } from '../data-card/DataDisabledCard';
import { DashboardMetricCardsProps } from './dashboard-metric-cards-helper';

export const DashboardMetricCards = ({
    dashboardMetricsQueryLoading,
    isBlobsServiceEnabled,
    totalNumberOfChains,
    metrics,
}: DashboardMetricCardsProps): React.JSX.Element => {
    return (
        <Grid container spacing={2.5} sx={dashboardStyles.metricsContainer}>
            <Grid item xs={10} md={2.4} sx={dashboardStyles.metricsCard}>
                <DataCard
                    label='Number of Chains'
                    value={
                        dashboardMetricsQueryLoading
                            ? 'Loading...'
                            : formattedMetricValues(totalNumberOfChains)
                    }
                    isLoading={dashboardMetricsQueryLoading}
                />
            </Grid>
            <Grid item xs={10} md={2.4} sx={dashboardStyles.metricsCard}>
                <DataCard
                    label='Number of Nodes'
                    value={
                        dashboardMetricsQueryLoading
                            ? 'Loading...'
                            : formattedMetricValues(metrics?.totalNodes ?? 0)
                    }
                    isLoading={dashboardMetricsQueryLoading}
                />
            </Grid>
            <Grid item xs={10} md={2.4} sx={dashboardStyles.metricsCard}>
                <DataCard
                    label='Number of Edges'
                    value={
                        dashboardMetricsQueryLoading
                            ? 'Loading...'
                            : formattedMetricValues(metrics?.totalEdges ?? 0)
                    }
                    isLoading={dashboardMetricsQueryLoading}
                />
            </Grid>
            <Grid item xs={10} md={2.4} sx={dashboardStyles.metricsCard}>
                {isBlobsServiceEnabled ? (
                    <DataCard
                        label='Number of Blobs'
                        value={
                            dashboardMetricsQueryLoading
                                ? 'Loading...'
                                : formattedMetricValues(
                                      metrics?.totalBlobs ?? 0
                                  )
                        }
                        isLoading={dashboardMetricsQueryLoading}
                    />
                ) : (
                    <DataDisabledCard
                        isLoading={dashboardMetricsQueryLoading}
                        label={'Number of Blobs'}
                    />
                )}
            </Grid>
            <Grid item xs={10} md={2.4} sx={dashboardStyles.metricsCard}>
                {isBlobsServiceEnabled ? (
                    <DataCard
                        label='Blob Size in Bytes'
                        value={
                            dashboardMetricsQueryLoading
                                ? 'Loading...'
                                : formattedByteValues(
                                      metrics?.totalBlobsBytes ?? 0
                                  )
                        }
                        isLoading={dashboardMetricsQueryLoading}
                    />
                ) : (
                    <DataDisabledCard
                        isLoading={dashboardMetricsQueryLoading}
                        label={'Blob Size in Bytes'}
                    />
                )}
            </Grid>
        </Grid>
    );
};
